<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>جزئیات {{lableText('TaskName')??'وظیفه'}}</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="card card-style bg-theme pb-0">
                <ul class="nav nav-pills mb-4 mx-3 mt-3 justify-content-center" id="pills-tab" role="tablist">
                    <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-details');">
                        <button class="nav-link text-center rounded-s w-100" :class="{'active':activeTabTitle=='#pills-details'}" id="pills-details-tab" data-toggle="pill" data-target="#pills-details" role="tab" aria-controls="pills-details" aria-selected="true" style="border: 1px solid #528edd">جزئیات</button>
                    </li>
                    <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-timeLine');">
                        <button class="nav-link text-center rounded-0 w-100" :class="{'active':activeTabTitle=='#pills-timeLine'}" id="pills-timeLine-tab" data-toggle="pill" data-target="#pills-timeLine" role="tab" aria-controls="pills-timeLine" aria-selected="false" style="border: 1px solid #528edd">سیر زمانی</button>
                    </li>
                    <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-taskworklist');">
                        <button class="nav-link text-center rounded-s w-100" :class="{'active':activeTabTitle=='#pills-taskworklist'}" id="pills-taskworklist-tab" data-toggle="pill" data-target="#pills-taskworklist" role="tab" aria-controls="pills-taskworklist" aria-selected="false" style="border: 1px solid #528edd">پیگیری‌ها</button>
                    </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade" id="pills-details" :class="{'active show':activeTabTitle=='#pills-details'}" role="tabpanel" aria-labelledby="pills-details-tab">
                        <div class="content mb-0 mt-0">
                            <div class="row mb-0 px-3">
                                <div class="col-6 px-1">
                                    <task-folder-list v-if="Loading==false && this.taskModel.taskId!=0" :taskFolderId="taskFolderId" :taskId="taskId"></task-folder-list>
                                    <!--<router-link v-if="taskModel.editable==true" :parentTaskFolderId="this.taskFolderId" class="btn btn-full btn-xxs rounded-s bg-magenta2-light font-900 mb-3 text-white w-100" :to="{ name: 'CreateTaskFolder', params: { taskFolderId: taskModel.taskFolderId,taskId:taskModel.taskId  } }">ارجاع وظیفه</router-link>-->
                                </div>
                            </div>
                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-hashtag brand-color"></i>
                                <span class="color-highlight" :class="{'input-style-1-active' : taskModel.taskNo!==null}">{{lableText('TaskNo')??'شماره وظیفه'}}</span>
                                <input class="form-control ltr d-inline-block" type="text" readonly v-model="taskModel.taskNo">

                            </div>

                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-calendar brand-color"></i>
                                <span class="color-highlight" :class="{'input-style-1-active' : taskModel.taskDate!==null}">{{lableText('TaskDate')??'تاریخ وظیفه'}}</span>
                                <input readonly class="form-control ltr d-inline-block" type="text" v-model="taskModel.taskDate">
                            </div>


                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-check-square brand-color"></i>
                                <span class="color-highlight input-style-1-active">{{lableText('Title')??'عنوان'}}</span>
                                <input class="form-control" type="text" v-model="taskModel.title" @input="v$.taskModel.title.$touch()" :class="{invalid:v$.taskModel.title.$error}" @blur="setDescription" :readOnly="taskModel.canEditInfo===false">
                                <p class="text-danger" v-if="v$.taskModel.title.required.$invalid && v$.taskModel.title.$dirty && taskModel.canEditInfo===true">لطفا {{lableText('Title')??'عنوان'}} را وارد کنید.</p>
                            </div>
                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-check brand-color"></i>
                                <span class="color-highlight input-style-1-active">{{lableText('TaskType')??'نوع وظیفه'}}</span>
                                <input class="form-control" type="text" v-model="taskModel.taskTypeTitle" readonly>
                            </div>

                            <div v-if="taskModel.canEditInfo===false" class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-calendar-check brand-color"></i>
                                <span class="color-highlight input-style-1-active">{{lableText('StartDateTime')??'تاریخ و ساعت شروع'}}</span>
                                <input class="form-control ltr d-inline-block" type="text" v-model="taskModel.startDateTime" readonly>
                            </div>
                            <div v-if="taskModel.canEditInfo===true">
                                <div class="input-style input-style-2 has-icon input-required">
                                    <i class="input-icon fa fa-calendar-check brand-color"></i>
                                    <span class="color-highlight" :class="{'input-style-1-active' : taskModel.startDateTime!==null}">{{lableText('StartDateTime')??'تاریخ و ساعت شروع'}}</span>
                                    <input type="text" class="form-control ltr d-inline-block" v-model="taskModel.startDateTime" id="startDT" :class="{invalid:v$.taskModel.startDateTime.$error}" />
                                </div>
                                <p class="text-danger" v-if="v$.taskModel.startDateTime.required.$invalid && v$.taskModel.startDateTime.$dirty">لطفا تاریخ و ساعت شروع را وارد کنید.</p>
                            </div>


                            <!--<div v-if="taskModel.canEditInfo===true" class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-history brand-color"></i>
                                <span class="color-highlight input-style-1-active">زمان معین شده1</span>
                                <input v-maska="'##:##'" placeholder="00:00" @blur="fixTime" class="form-control ltr d-inline-block" type="tel" v-model="taskModel.suggestedPersonTime" @input="v$.taskModel.suggestedPersonTime.$touch()" :class="{invalid:v$.taskModel.suggestedPersonTime.$error}">
                                <p class="text-danger" v-if="taskModel.canEditInfo===true && v$.taskModel.suggestedPersonTime.required.$invalid && v$.taskModel.suggestedPersonTime.$dirty">لطفا زمان معین شده را وارد کنید.</p>

                            </div>-->

                            <div class="mb-4">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center">
                                        <i class="fa fa-clock pl-2 brand-color"></i>
                                        <label class="mb-0 font-12 font-weight-bold">زمان معین شده</label>
                                    </div>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                            <span class="font-13 font-weight-bold px-3"></span>
                                            <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                        </div>
                                        <div class="ltr">
                                            <input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeHour" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeHour.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeHour.$error}">
                                            <span class="font-13 font-weight-bold px-2">:</span>
                                            <input placeholder="00" @input="() => { if(taskModel.suggestPersonTimeMinute > 59 || taskModel.suggestPersonTimeMinute < 0) { taskModel.suggestPersonTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">
                                        </div>
                                    </div>
                                </div>
                                <p class="text-danger mt-2" v-if="v$.taskModel.suggestPersonTimeHour.between.$invalid && v$.taskModel.suggestPersonTimeHour.$dirty">ساعت باید مقداری از ۰ تا ۱۰۰۰ داشته باشد.</p>
                                <p class="text-danger mt-2" v-if="v$.taskModel.suggestPersonTimeMinute.between.$invalid && v$.taskModel.suggestPersonTimeMinute.$dirty">دقیقه باید مقداری از ۰ تا ۵۹ داشته باشد.</p>
                                <p class="text-danger " v-if="v$.taskModel.suggestedPersonTime.required.$invalid && v$.taskModel.suggestedPersonTime.$dirty">لطفا زمان معین شده را وارد کنید.</p>

                            </div>


                            <div class="input-style input-style-2 has-icon input-required" v-if="taskModel.canEditInfo===false">
                                <i class="input-icon fa fa-calendar-times brand-color"></i>
                                <span class="color-highlight input-style-1-active">{{lableText('EndDateTime')??'تاریخ و ساعت پایان'}}</span>
                                <input class="form-control ltr d-inline-block" type="text" v-model="taskModel.endDateTime" readonly>
                            </div>
                            <div>
                                <div class="input-style input-style-2 has-icon input-required" v-if="taskModel.canEditInfo===true">
                                    <i class="input-icon fa fa-calendar-times brand-color"></i>
                                    <span class="color-highlight" :class="{'input-style-1-active' : taskModel.endDateTime!==null}">{{lableText('EndDateTime')??'تاریخ و ساعت پایان'}}</span>
                                    <input type="text" class="form-control ltr d-inline-block" v-model="taskModel.endDateTime" id="endDT" :class="{invalid:v$.taskModel.endDateTime.$error}" />
                                </div>
                                <p class="text-danger" v-if="v$.taskModel.endDateTime.required.$invalid && v$.taskModel.endDateTime.$dirty">لطفا {{lableText('EndDateTime')??'تاریخ و ساعت پایان'}} را وارد کنید.</p>

                            </div>


                            <div class="mb-3" v-if="taskModel.canEditInfo">
                                <div class="mb-3">
                                    <v-select dir="rtl" label="title" placeholder="ضرورت" :filterable="false" :searchable="false" :options="PreferenceTypeList" :reduce="p => p.preferenceTypeId" v-model="taskModel.preferenceTypeId">

                                    </v-select>
                                </div>
                            </div>

                            <div v-else class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-star brand-color"></i>
                                <span class="color-highlight input-style-1-active">ضرورت</span>
                                <input class="form-control" type="text" v-model="taskModel.preferenceTypeTitle" readonly>
                            </div>


                            <div class="mb-3" v-if="taskModel.canEditInfo">
                                <v-select :class="{invalid:v$.taskModel.priorityId.$error}" dir="rtl" label="title" :placeholder="lableText('PriorityId')??'اولویت'" :filterable="false" :searchable="false" :options="priorityList" :reduce="p => p.priorityId" v-model="taskModel.priorityId">
                                    <template slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                                <p class="text-danger" v-if="v$.taskModel.priorityId.required.$invalid && v$.taskModel.priorityId.$dirty">لطفا {{lableText('PriorityId')??'اولویت'}} را وارد کنید.</p>
                            </div>

                            <div v-else class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-star brand-color"></i>
                                <span class="color-highlight input-style-1-active">{{lableText('PriorityId')??'اولویت'}}</span>
                                <input class="form-control" type="text" v-model="taskModel.priorityTitle" readonly>
                            </div>

                            <div class="input-style input-style-2 has-icon input-required" v-show="isFieldEnabled('WorkGroupId')">
                                <i class="input-icon fa fa-users brand-color"></i>
                                <span class="color-highlight" :class="{'input-style-1-active' : taskModel.workGroupTitle!==null}">{{lableText('WorkGroupId')??'گروه کاری (کارگروه)'}}</span>
                                <input class="form-control" type="text" v-model="taskModel.workGroupTitle" readonly>
                            </div>

                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-user-check brand-color"></i>
                                <span class="color-highlight input-style-1-active">ارجاع دهنده</span>
                                <input class="form-control" type="text" v-model="taskModel.referrerFolderUserTitle" readonly>
                            </div>
                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-user-plus brand-color"></i>
                                <span class="color-highlight input-style-1-active">ارجاع گیرنده</span>
                                <input class="form-control" type="text" v-model="taskModel.receiverUserTitle" readonly>
                            </div>


                            <div class="collapse pt-1" id="collapse-8">


                                <div class="mb-3">
                                    <v-select v-if="taskModel.receiverUserId!=null" v-show="isFieldEnabled('TeamUserIdsList')" :readOnly="taskModel.canEditInfo!==true" dir="rtl" label="title" :placeholder="lableText('TeamUserIdsList')??'سایر کاربران (اعضای تیم/ ناظرین)'" multiple chips :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListListForTeam" :reduce="p => p.userId" v-model="taskModel.teamUserIdsList">
                                        <template slot="option">
                                            <div class="d-center">
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>




                                <div v-show="isFieldEnabled('RefPersonId')">
                                    <div class="mb-3" v-if="!isMinVersion">
                                        <div class="d-flex">
                                            <div class="w-100">
                                                <v-select dir="rtl" v-model="taskModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                                    <template v-slot="option">
                                                        <div class="d-center">
                                                            {{ option.title }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div v-show="isFieldEnabled('ProjectId')">
                                    <div class="mb-3">
                                        <div class="d-flex">
                                            <div class="w-100">
                                                <v-select dir="rtl" v-model="taskModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                                    <template v-slot="option">
                                                        <div class="d-center">
                                                            {{ option.fullTitle }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>




                                <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="taskModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3" v-if="!isMinVersion">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="taskModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3" v-if="!isMinVersion">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="taskModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3" v-if="!isMinVersion">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="taskModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="taskModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="taskModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="input-style input-style-2 has-icon">
                                    <i class="input-icon fa fa-check-square brand-color"></i>
                                    <span class="color-highlight input-style-1-active">آخرین وضعیت</span>
                                    <input class="form-control" type="text" v-model="taskModel.stepTitle" disabled="true">
                                </div>

                                <div class="input-style input-style-2 has-icon input-required">
                                    <i class="input-icon fa fa-check-square brand-color"></i>
                                    <span :class="{'input-style-1-active' : taskModel.reference!==null}" class="color-highlight">شناسه</span>
                                    <input maxlength="150" class="form-control" type="text" v-model="taskModel.reference" :readOnly="taskModel.canEditInfo===false">
                                </div>

                                <div v-show="isFieldEnabled('ReminderDateTime')">
                                    <div class="input-style input-style-2 has-icon input-required">
                                        <i class="input-icon fa fa-calendar-check brand-color"></i>
                                        <span class="color-highlight" :class="{'input-style-1-active' : taskModel.reminderDateTime!==null}">{{lableText('ReminderDateTime')??'زمان یادآوری'}}</span>
                                        <input type="text" class="form-control ltr d-inline-block" v-model="taskModel.reminderDateTime" id="reminderDT" :readOnly="taskModel.canEditInfo===false" />
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <!--<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                                        <button data-toggle="collapse" data-target="#collapse-description">
                                            <i class="fa fa-edit mt-2"></i>
                                            <span>{{lableText('Description')??'توضیحات'}}</span>
                                            <i class="fa fa-angle-down"></i>
                                        </button>
                                    </div>-->
                                    <div id="collapse-description" v-if="taskModel.canEditInfo===false">
                                        <div class="form-control font-12 line-height-m text-justify div-description rounded-sm" v-html="taskModel.description" style="height:200px"></div>
                                    </div>

                                    <div id="collapse-description" v-if="taskModel.canEditInfo===true">
                                        <textarea v-model="taskModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px" @input="v$.taskModel.description.$touch()" :class="{invalid:v$.taskModel.description.$error}" placeholder="توضیحات"></textarea>
                                        <p class="text-danger" v-if="v$.taskModel.description.required.$invalid && v$.taskModel.description.$dirty">لطفا {{lableText('Description')??'توضیحات'}} را وارد کنید.</p>

                                    </div>

                                </div>
                                <button v-if="taskModel.canEditInfo===true" class="btn btn-link speechToTextBtn mb-3" @pointerdown="startR" @pointerup="stopR">
                                    <span :class="btnRecord">
                                        <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                                    </span>
                                    <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                                </button>
                            </div>
                            <button data-toggle="collapse" data-target="#collapse-8" class="btn btn-xxs btn-full mb-3 rounded-sm bg-highlight font-900 collapse-a w-100 collapsed" id="moreLessDetails" @click="toggleClasslessDetails()" aria-expanded="false"><span class="collapse-a-title"></span></button>

                            <taskfolderitem-list v-if="taskModel.taskId!=null" :taskId="$route.params.taskId" :taskFolderId="$route.params.taskFolderId" :readOnly="taskModel.readOnlyFolderItem"></taskfolderitem-list>

                            <att-list :docId="0" v-if="taskModel.taskNo!=null" v-bind:destination="'TaskFolder'" :oldAttList="taskModel.attList" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="taskModel.canEditInfo" :canDelete="taskModel.canEditInfo" :hasLocation="true"></att-list>
                            <button :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="CheckTaskTitle" v-if="taskModel.canEditInfo===true">
                                <i class="fa fa-check font-10 ml-2"></i>
                                ثبت
                            </button>
                        </div>

                    </div>
                    <div class="tab-pane fade" id="pills-timeLine" :class="{'active show':activeTabTitle=='#pills-timeLine'}" role="tabpanel" aria-labelledby="pills-timeLine-tab">
                        <task-time-line v-if="taskModel.taskId!=null" :taskId="taskModel.taskId" :taskFolderId="folderIdForTimeLine"></task-time-line>
                    </div>
                    <div class="tab-pane fade" id="pills-taskworklist" :class="{'active show':activeTabTitle=='#pills-taskworklist'}" role="tabpanel" aria-labelledby="pills-taskworklist-tab">
                        <task-work-list v-if="taskModel.taskId!=null" :taskId="taskModel.taskId" :taskFolderId="taskFolderId"></task-work-list>

                    </div>
                </div>
            </div>
        </div>
        <date-picker v-if="taskModel.canEditInfo===true" type="datetime" v-model="taskModel.startDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="startDT" :jump-minute="5" />
        <date-picker v-if="taskModel.canEditInfo===true" type="datetime" v-model="taskModel.endDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="endDT" :jumpMinute="5" />
        <date-picker v-if="taskModel.canEditInfo===true" type="datetime" v-model="taskModel.reminderDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="reminderDT" :jump-minute="5" />
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید...</div>
            </div>
        </transition>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="taskModel.editable==true && pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link :parentTaskFolderId="this.taskFolderId" :to="{ name: 'CreateTaskFolder', params: { taskFolderId: taskFolderId,taskId:taskId  } }">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-share-square"></i>
                    </div>
                </router-link>
            </div>
        </transition>

    </div>
</template>

<script>
    import useVuelidate from '@vuelidate/core'
    import { required, between } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import taskFolderListModal from './TaskFolderList.vue'
    import timeLine from './TimeLine.vue'
    import taskWorkList from './TaskWorkList.vue'
    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';
    import TaskFolderItemList from './TaskFolderItemList.vue';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            "att-list": AttList,
            "task-folder-list": taskFolderListModal,
            "task-time-line": timeLine,
            "task-work-list": taskWorkList,
            DatePicker,
            "taskfolderitem-list": TaskFolderItemList
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                taskId: this.$route.params.taskId,
                taskFolderId: 0,
                activeTabTitle: "#pills-details",
                attInProgress: false,
                currentUserId: 0,
                showType: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                taskModel: {
                    taskNo: null,
                    taskDate: null,
                    title: null,
                    taskTypeId: null,

                    receiverUserId: null,
                    priorityId: null,
                    suggestedPersonTime: "",
                    startDateTime: this.$store.getters.GetServerDateTime,
                    startTime: null,
                    endDateTime: null,
                    endTime: null,

                    refPersonId: null,
                    description: null,
                    refPersonTitle: null,
                    taskTypeTitle: null,
                    workGroupTitle: null,
                    referrerFolderUserTitle: null,
                    receiverUserTitle: null,
                    prioriotyTitle: null,
                    editable: null,
                    canEditInfo: false,
                    attList: [],
                    reference: null,
                    reminderDateTime: null,
                    stepTitle: null,
                    teamUserIdsList: [],
                    teamUserIds: null,
                    readOnlyFolderItem: false,
                    suggestPersonTimeHour: null,
                    suggestPersonTimeMinute: null,



                    leadId: null,
                    workGroupId: null,
                    projectId: null,
                    invoiceId: null,
                    preInvoiceId: null,
                    contractId: null,
                    letterId: null,
                    personId: null,
                    meetingId: null,
                    preBuyInvoiceId: null,
                    buyId: null,

                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                    isLoad: false,


                    preferenceTypeTitle: "",
                    preferenceTypeId: null
                },
                pageLoaded: false
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            PreferenceTypeList() {
                return this.$store.getters.GetPreferenceTypeList;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
            localUserListListForTeam() {
                var list = this.$store.getters.GetLocalUserListList;
                return list.filter(x => x.userId !== this.taskModel.receiverUserId && x.userId !== this.currentUserId);
            },
            folderIdForTimeLine() {
                var folderId = this.taskModel.parentFolderId || this.taskFolderId;
                return folderId;
            },
            priorityList() {
                return this.$store.getters.GetPriorityList;
            },



            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            WorkGroupList() {
                return this.$store.getters.GetWorkGroupList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        },
        watch: {
            'taskModel.workGroupId'(value) {
                if (this.taskModel.isLoad)
                    this.onChangeWorkGroup();
            },
            'taskModel.personId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangePerson();
            },
            'taskModel.projectId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangeProject();
            },
            'taskModel.preInvoiceId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangePreInvoice();
            },
            'taskModel.contractId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangeContract();
            },
            'taskModel.meetingId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangeMeeting();
            },
            'taskModel.invoiceId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangeInvoice();
            },
            'taskModel.letterId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangeLetter();
            },
            'taskModel.buyId'(value) {
                if (this.taskModel.isLoad)
                    this.onchangeBuy();
            },
        },
        created() {
            this.$store.dispatch("CheckUserSMS");
            var activeTabTitle = location.hash;
            if (activeTabTitle != "") {
                this.activeTabTitle = activeTabTitle;
            }
            this.GetCurrenctUserId();
            this.GetTaskItem();
            this.$store.dispatch("GetPriorityListFromServer");
            this.$store.dispatch("GetPreferenceTypeListFromServer", {});
        },
        methods: {
            toggleClasslessDetails() {
                var element = document.getElementById("moreLessDetails");
                element.classList.toggle("lessDetails");
            },
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.taskModel.projectId = null;
                this.taskModel.invoiceId = null;
                this.taskModel.preInvoiceId = null;
                this.taskModel.contractId = null;
                this.taskModel.letterId = null;
                this.taskModel.meetingId = null;
                this.taskModel.preBuyInvoiceId = null;
                this.taskModel.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.taskModel.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.taskModel.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.taskModel.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.taskModel.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.taskModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskModel.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.taskModel.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.taskModel.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.taskModel.contractId = null;
                this.taskModel.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.taskModel.personId,
                    projectId: this.taskModel.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskModel.personId,
                    projectId: this.taskModel.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.taskModel.personId,
                        projectId: this.taskModel.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.taskModel.contractId = null;
                this.taskModel.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.taskModel.preInvoiceId,
                    contractId: this.taskModel.contractId,
                    personId: this.taskModel.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.taskModel.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.taskModel.invoiceId = null;
                this.taskModel.buyId = null;
                this.taskModel.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.taskModel.preInvoiceId,
                    contractId: this.taskModel.contractId,
                    personId: this.taskModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskModel.personId,
                    projectId: this.taskModel.projectId,
                    contractId: this.taskModel.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.taskModel.personId,
                    prebuyInvoiceId: this.taskModel.prebuyInvoiceId,
                    contractId: this.taskModel.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.taskModel.preInvoiceId,
                        contractId: this.taskModel.contractId,
                        personId: this.taskModel.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        personId: this.taskModel.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.taskModel.personId,
                        contractId: this.taskModel.contractId,
                        projectId: this.taskModel.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.taskModel.personId,
                        prebuyInvoiceId: this.taskModel.prebuyInvoiceId,
                        contractId: this.taskModel.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },




            onChangeWorkGroup() {
                console.log("")

            },


            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }

            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            EditTask() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    if (this.taskModel.teamUserIdsList !== null) {
                        this.taskModel.teamUserIds = this.taskModel.teamUserIdsList.join(",");
                    }
                    this.$store.dispatch("EditTask", this.taskModel);
                }

            },
            GetCurrenctUserId() {
                this.$http.get("Task/getCurrentUserId")
                    .then(data => {
                        this.currentUserId = data.data;
                    });
            },
            showAddButton() {
                this.pageLoaded = true;

            },
            GetTaskItem() {
                var folderId = this.$route.params.taskFolderId;


                this.$http.get("Task/EidtTask?taskId=" + this.taskId + "&taskFolderId=" + folderId)
                    .then(data => {
                        this.$store.dispatch("GetPersonListFromServer", {
                            text: "",
                            personId: data.data.personId,
                        }).then(a => {

                            this.$store.dispatch("GetProjectListFromServer", {
                                text: "",
                                personId: data.data.personId,
                                projectId: data.data.projectId,
                            }).then(b => {
                                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                                    text: "",
                                    personId: data.data.personId,
                                    preInvoiceId: data.data.preInvoiceId,
                                }).then(c => {
                                    this.$store.dispatch("GetContractAbstractForPerson", {
                                        personId: data.data.personId,
                                        projectId: data.data.projectId,
                                        contractId: data.data.contractId,
                                    }).then(d => {
                                        this.$store.dispatch("GetInvoiceAbstractForPerson", {
                                            invoiceId: data.data.invoiceId,
                                            preInvoiceId: data.data.preInvoiceId,
                                            contractId: data.data.contractId,
                                            personId: data.data.personId,
                                        }).then(e => {
                                            this.$store.dispatch("GetLetterAbstractForPerson", {
                                                letterId: data.data.letterId,
                                                personId: data.data.personId,
                                            }).then(f => {
                                                this.$store.dispatch("GetMeetingAbstractForPerson", {
                                                    personId: data.data.personId,
                                                    contractId: data.data.contractId,
                                                    projectId: data.data.projectId,
                                                    meetingId: data.data.meetingId,
                                                }).then(g => {
                                                    this.$store.dispatch("GetBuyAbstractForPerson", {
                                                        personId: data.data.personId,
                                                        prebuyInvoiceId: data.data.prebuyInvoiceId,
                                                        buyId: data.data.buyId,
                                                        contractId: data.data.contractId,
                                                    }).then(h => {
                                                        this.$store.dispatch("GetWorkGroupListFromServer", {

                                                            workGroupId: data.data.workGroupId
                                                        }).then(i => {
                                                            this.taskModel = data.data;
                                                            if (this.taskModel.taskFolderId == null) {
                                                                this.taskFolderId = data.data.parentFolderId;
                                                            }
                                                            else {
                                                                this.taskFolderId = data.data.taskFolderId;
                                                            }
                                                            this.$http.get("Task/TaskOnline_GetUserActiveStatus")
                                                                .then(data => {
                                                                    this.taskModel.isLoad = true;
                                                                });


                                                        })
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });


                //this.$http.get("Task/EidtTask?taskId=" + this.taskId + "&taskFolderId=" + folderId)
                //	.then(data => {
                //		this.taskModel = data.data;
                //		if (this.taskModel.taskFolderId == null) {
                //			this.taskFolderId = data.data.parentFolderId;
                //		}
                //		else {
                //			this.taskFolderId = data.data.taskFolderId;
                //		}


                //	});
            },
            SetAttList(e) {
                console.log(e);
                this.taskModel.attList = e;
            },
            onTabClick(title) {
                console.log(title);
            },
            setDescription() {
                if (this.taskModel.description == null || this.taskModel.description == "") {
                    this.taskModel.description = this.taskModel.title;
                }
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            CheckTaskTitle() {
                this.taskModel.suggestedPersonTime = this.taskModel.suggestPersonTimeHour + this.taskModel.suggestPersonTimeMinute;

                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) {
                    this.$http.get("Task/CheckTaskTitle?taskId=" + this.taskModel.taskId + "&taskTypeId=" + this.taskModel.taskTypeId + "&title=" + this.taskModel.title)
                        .then(data => {
                            if (data.data.toString() === "1") {
                                this.EditTask();
                            }
                            else {
                                VueSimpleAlert.fire({
                                    title: data.data,
                                    showCancelButton: true,
                                    confirmButtonText: 'تأیید و ثبت ',
                                    cancelButtonText: `انصراف`,
                                }).then((result) => {
                                    if (result.value == true) {
                                        this.EditTask();
                                    } else {
                                        console.log("cancel save");
                                    }


                                })
                            }
                        });
                }

            },
            fixTime() {

                var val = this.taskModel.suggestedPersonTime;
                if (val.length == 1) {
                    val = '0' + val + ':00';
                }
                else if (val.length == 2) {
                    val = val + ':00';
                }
                else if (val.length == 4) {
                    val = val + '0';
                }
                this.taskModel.suggestedPersonTime = val;
            },
        },
        validations: {
            taskModel: {
                taskNo: {
                    required,
                },
                taskDate: {
                    required
                },
                title: {
                    required
                },
                priorityId: {
                    required
                },
                taskTypeId: {
                    required
                },
                receiverUserId: {
                    required
                },
                suggestedPersonTime: {
                    required
                },
                startDateTime: {
                    required
                },
                endDateTime: {
                    required
                },
                description: {
                    required
                },
                suggestPersonTimeHour: {
                    between: between(0, 1000)
                },
                suggestPersonTimeMinute: {
                    between: between(0, 59)
                },
            }


        },
        directives: { maska },
        mounted() {
            try {

                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");


                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.taskModel.description == null || this.taskModel.description == "null")
                        this.taskModel.description = "";
                    if (rest != null && rest != '')
                        this.taskModel.description = this.taskModel.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
            }
            this.showAddButton();
            setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)
        },
    };
</script>
